"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomIcon_1 = require("../atoms/ATLAtomIcon");
var ATLAtomIconButton_1 = require("../atoms/ATLAtomIconButton");
var injectStyleProp_1 = require("../utils/injectStyleProp");
var ReturnKeyTypeEnum_1 = require("../enums/ReturnKeyTypeEnum");
var defaultProps = {
    complementaryPrimary: false,
    complementarySecondary: false,
    hideClearButton: false,
    isLoading: false,
    clearButtonBaseProps: {},
    iconBaseProps: {}
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var closeIcon = require('../assets/close.png');
var searchIcon = require('../assets/icSearch.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.MoleculeWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (props) { return props.moleculeBackgroundColor; });
exports.SearchTextInput = native_1.default(react_native_1.TextInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  margin: 0 0 0 ", "px;\n  padding: 0;\n  height: ", "px;\n  justify-content: center;\n  font-size: 14px;\n  color: ", ";\n"], ["\n  flex: 1;\n  margin: 0 0 0 ", "px;\n  padding: 0;\n  height: ", "px;\n  justify-content: center;\n  font-size: 14px;\n  color: ", ";\n"])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.HeightButtonBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.complementary ? atlTheme.ColorComplementary1 : atlTheme.ColorHighContrast;
});
exports.SearchBoxWrapper = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  padding: 0 8px;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n  margin: ", "px\n          ", "px;\n"], ["\n  flex-direction: row;\n  align-items: center;\n  padding: 0 8px;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n  margin: ", "px\n          ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (props) { return props.borderColor; }, function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.BorderRadiusButton;
}, function (props) { return props.boxBackgroundColor; }, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLSearchBox = function (_a) {
    var value = _a.value, onChange = _a.onChange, placeholderText = _a.placeholderText, complementaryPrimary = _a.complementaryPrimary, complementarySecondary = _a.complementarySecondary, hideClearButton = _a.hideClearButton, isLoading = _a.isLoading, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, clearButtonBaseProps = _a.clearButtonBaseProps, iconBaseProps = _a.iconBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var _b = react_1.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var handleFocus = function () { return setIsFocused(true); };
    var handleBlur = function () { return setIsFocused(false); };
    var boxColorRegular = isFocused ? theme.ColorBrand1Default : theme.ColorLowContrast;
    var boxColorComplementary = injectStyleProp_1.injectStyleColor(theme.ColorComplementary1, 0.3, !isFocused);
    // Function that cleans field
    var onClearPressed = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            onChange && onChange('');
            return [2 /*return*/];
        });
    }); }, [value]);
    // Renders clear icon button when there is text in the input
    var renderClearButton = function () { return (react_1.default.createElement(ATLAtomIconButton_1.ATLAtomIconButton, __assign({ icon: closeIcon, iconColor: complementaryPrimary || complementarySecondary ? injectStyleProp_1.injectStyleColor(theme.ColorComplementary1, 0.3, true) : theme.ColorLowContrast, onPress: onClearPressed, iconSize: theme.SizeIconBase, buttonSize: theme.SizeIconBase, buttonColor: theme.ColorNone, buttonBorderWidth: 0 }, clearButtonBaseProps))); };
    // Renders loading instead of clean button if isLoading = true
    var renderLoading = function () { return (react_1.default.createElement(react_native_1.ActivityIndicator, { size: 'small', color: complementaryPrimary || complementarySecondary ? theme.ColorComplementary1 : theme.ColorLowContrast })); };
    // Renders textInput
    var renderInput = function () { return (react_1.default.createElement(exports.SearchTextInput, { value: value && value, onChangeText: onChange, complementary: complementaryPrimary || complementarySecondary, placeholder: isFocused ? '' : placeholderText, placeholderTextColor: complementaryPrimary || complementarySecondary ? boxColorComplementary : theme.ColorLowContrast, selectionColor: complementaryPrimary || complementarySecondary ? theme.ColorComplementary1 : theme.ColorBrand1Default, onFocus: handleFocus, onBlur: handleBlur, returnKeyType: ReturnKeyTypeEnum_1.ReturnKeyTypeEnum.search, textAlignVertical: 'center', spellcheck: false })); };
    var boxBackgroundColor;
    var moleculeBackgroundColor;
    if (complementaryPrimary) {
        boxBackgroundColor = theme.ColorBrand1High;
        moleculeBackgroundColor = theme.ColorBrand1Default;
    }
    else if (complementarySecondary) {
        boxBackgroundColor = theme.ColorBrand2High;
        moleculeBackgroundColor = theme.ColorBrand2Default;
    }
    else {
        boxBackgroundColor = theme.ColorNone;
        moleculeBackgroundColor = theme.ColorNone;
    }
    // Returns full ATLSearchBox
    return (react_1.default.createElement(exports.MoleculeWrapper, { moleculeBackgroundColor: moleculeBackgroundColor },
        react_1.default.createElement(exports.SearchBoxWrapper, { boxBackgroundColor: boxBackgroundColor, borderColor: complementaryPrimary || complementarySecondary ? theme.ColorNone : boxColorRegular, horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
            react_1.default.createElement(ATLAtomIcon_1.ATLAtomIcon, __assign({ source: searchIcon, size: theme.SizeIconBase, tintColor: complementaryPrimary || complementarySecondary ? boxColorComplementary : boxColorRegular }, iconBaseProps)),
            renderInput(),
            isLoading ? renderLoading() : (value !== '' && !hideClearButton && renderClearButton()))));
};
exports.ATLSearchBox.defaultProps = defaultProps;
exports.ATLSearchBox.displayName = 'ATLSearchBox';
var templateObject_1, templateObject_2, templateObject_3;
